import React, { Component } from 'react'
import { Snackbar } from '@material-ui/core';

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

/* Redux */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import mainLogoM from '../../images/portal/logo-big@2x.png';

import succ from '../../images/fit/succ-sign.png';

import { removeSuccessMessage } from '../../Actions/SuccessMessagesActions';

/* Components */
import Footer from '../components/Layout/Footer';
import FitDownloadApps from '../components/Layout/FitDownloadApps'

import "../../css/Fit.css";


class MwBahrainSuccess extends Component {

    state = {
        mwCompanyContent: "",
        phoneNumber: "",
        openSnakBar: false,

        vertical: 'bottom',
        horizontal: 'right',
    }

    componentDidMount() {
        let phone = this.props.match.params.phone;
        let mwCompanyContent;

        this.setState({ phoneNumber: phone })

    }

    handleSuccessMessages = () => {
        this.props.removeSuccessMessage();
    }

    render() {
	
	//console.log('BahrainSuccess page: props is :'+JSON.stringify(this.props,null,3));
	//console.log('BahrainSuccess page: state is :'+JSON.stringify(this.state,null,3));
	
        const { vertical, horizontal } = this.state;
        const { successMessage } = this.props;

        return (
            <div>

                <Snackbar
                    autoHideDuration={6000} 
                    onClose={this.handleSuccessMessages}
                    anchorOrigin={{ vertical, horizontal }}
                    open={successMessage.show}
                    message={successMessage.message}
                    key={vertical + horizontal}
                />

                <section className="jeel-fit">
                    <div className="logo-container">
                        <div className="container">
                            <div className="logo">
                                <img src={mainLogoM} alt="logo" />
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-12 col-md-6">
                                <div className="center fit-about-text">
                                    <div className="title h2 white">

                                        بعد اشتراكك عبر الرسائل النصية،
                                        كل ما عليك الآن هو
                                            </div>
                                </div>
                            </div>

                        </div>
                        <div className="row justify-content-md-center">

                            <div className="col-12 col-md-6">
                                <div className="  main-progress-bar">
                                    <ol className="progress-tracker">
                                        <li className="step fitbg">
                                            <span className="step-name small-font">
                                                <span className="bold">
                                                    تفعيل الحساب
                                                    </span>
                                            </span>
                                        </li>
                                        <li className="step fit">
                                            <span className="step-name small-font">
                                                <span className="bold">
                                                    تحميل التطبيق
                                                </span>
                                            </span>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>


                <div className="container" >

                    <div className=" col-12 col-md-8" id="border">

                        <div className=" center img">
                            <img src={succ} alt="logo" />
                            <br /><br />

                            <strong>
                                مُبارك!
                                </strong>

                        </div>

                        <div className="row justify-content-md-center">
                            <div className=" col-12 col-md-8">

                                <p className="h5 text-rtl">
                                    اشتركت بنجاح في باقة شركات الاتصالات،
                                    وستُجدَّدُ الباقة تلقائيًا بعد انتهائها.
                                    </p>
                            </div>
                        </div>

                        <br />

                    </div>
                </div>
                <div className="container" >
                    <div className=" col-12 col-md-8" id="border">

                        <div className="row justify-content-md-center">

                            <div className="col-12 col-md-8 ">

                                <p className="h5 text-rtl margin">
                                    رقم الهاتف الذى تم الاشتراك من خلاله
                                        </p>
                                <br />
                                <div className="phoneNum" id="phone">
                                    <PhoneInput
                                        name="phone"
                                        value={this.state.phoneNumber}
                                        disabled />
                                </div>
                                <br />

                                <p className="cancel small-font font-weight-bold text-rtl">
                                    {this.state.mwCompanyContent}
                                </p>
                                <br />
                                <br />
                            </div>

                        </div>
                    </div>


                </div>


                <div className="container" >
                    <div className=" col-12 col-md-8" id="border"
                    >

                        {/** download section */}
                        <FitDownloadApps />
                        {/** End of download section*/}
                    </div>
                </div>





                {/** Start Footer */}
                <Footer />
                {/** End Footer */}

            </div>
        )
    }
}

const mapStateToProps = state => ({

    successMessage: state.successMessages.item,
});


export default withRouter
    (connect
        (mapStateToProps,
            {
                removeSuccessMessage,
            })
        (MwBahrainSuccess)
    );

